import {
  Chip, ChipProps
} from "@mui/material";

import {
  InProgressIcon, ProgressIcon, FinishedIcon, ErrorIcon
} from 'shared/icons';

export const SearchStatusChip = (props: {
  status: number;
} & ChipProps) => {
  const { status, ...others } = props;
  if (status === 0 || status === 1) return <Chip label='待機' {...others} color="secondary" icon={<InProgressIcon />} />;
  if (status === 2) return <Chip label='処理中' {...others} color="primary" icon={<ProgressIcon/>} />;
  if (status === 8) return <Chip label='分析済' {...others} color="success" icon={<FinishedIcon/>} />;
  return <Chip label='エラー' {...others} color="error" icon={<ErrorIcon/>} />;
}
